import NavBar from "../../components/navBar/NavBar";
import ContactSection from "../../section/contactSection/ContactSection";
import HomeSection from "../../section/homeSection/HomeSection";
import AboutSection from "../../section/aboutSection/AboutSection";
import ProjectSection from "../../section/projectSection/ProjectSection";
import Qualification from "../../section/qualification/Qualification";
import './style.css';


export default function Home() {
    return(
        <div className="home">
            <NavBar/>
            <div className="home-container">
                <HomeSection/>
                <AboutSection/>
                <Qualification/>
                <ProjectSection/>
                <ContactSection/>
            </div>
        </div>
    );
}